module.exports = __webpack_public_path__ + "static/media/compensacion.f559cca6.svg";